// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data__range__box {
    margin: .3rem 0;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-size: 1.3rem;
    color: #8C8C8B;
}

.data__range__box:hover {
    color: #1a5fa8;
}

.date__range__format { 
    margin-right: 0;
}

.react-calendar {
    max-width: 100%;
    font-family: 'Segoe UI', sans-serif;
    border: 1px solid #D5D5D5;
    border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/components/ClearBI/DateRangeCBI.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mCAAmC;IACnC,yBAAyB;IACzB,kBAAkB;AACtB","sourcesContent":[".data__range__box {\n    margin: .3rem 0;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n    font-size: 1.3rem;\n    color: #8C8C8B;\n}\n\n.data__range__box:hover {\n    color: #1a5fa8;\n}\n\n.date__range__format { \n    margin-right: 0;\n}\n\n.react-calendar {\n    max-width: 100%;\n    font-family: 'Segoe UI', sans-serif;\n    border: 1px solid #D5D5D5;\n    border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
